import { useState, useEffect } from 'react';
import AsyncSelect from "react-select/async";
import { useNavigate, useLocation } from 'react-router-dom';
import back_arrow from "../../assets/svg/back-arrow.svg";
import '../../styles/RoleMaster.css';
import Masters_header from './Masters_header';
import axiosInstance from '../../axiosInstance';
import { components } from 'react-select';
import { ToastContainer, toast } from "react-toastify";
import Select from 'react-select';
import CommonFooter from '../../CommonFooter/CommonFooter';


const RoleCreation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const isEdit = state?.isEdit || false;
  const editData = state?.editData || null;
  const roleId = state?.roleId || null;
  const [modulesEnabled, setModulesEnabled] = useState(true);
  const [selectedModule, setSelectedModule] = useState('projectCreation');
  const [selectedDesignations, setSelectedDesignations] = useState([]);
  const [designationInputValue, setDesignationInputValue] = useState('');
  const [designationOptions, setDesignationOptions] = useState([]);
  const [moduleList, setModuleList] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [additionalFeatures, setAdditionalFeatures] = useState([]);
  const [selectedAdditionalFeatures, setSelectedAdditionalFeatures] = useState([]);
  const [moduleAdditionalFeatures, setModuleAdditionalFeatures] = useState({});
  const [moduleIds, setModuleIds] = useState([]);
  const isClone = state?.isClone || false;
  const cloneData = state?.cloneData || null;

  const [formData, setFormData] = useState({
    role_code: isClone ? '' : editData?.role_code || '',
    role_name: isClone ? '' : editData?.role_name || '',
    designation_type_id: isClone ? '' : (editData?.designation_type_id?.join(',') || '')
  });


  useEffect(() => {
    if (loaded && (isEdit || isClone)) {
      const sourceData = isEdit ? editData : cloneData;

      if (sourceData) {
        setFormData({
          role_code: isClone ? '' : sourceData.role_code || '',
          role_name: isClone ? '' : sourceData.role_name || '',
          designation_type_id: isClone ? '' : (sourceData.designation_type_id?.join(',') || '')
        });

        if (!isClone && sourceData.designation_type_id && sourceData.designation_names) {
          const designationOptions = sourceData.designation_type_id.map(id => ({
            value: id,
            label: sourceData.designation_names[id] || `Designation ${id}`
          }));
          setSelectedDesignations(designationOptions);
        } else {
          setSelectedDesignations([]); 
        }

        if (sourceData.permissions) {
          const newModuleSettings = { ...moduleSettings };
          const newSubmoduleStates = { ...submoduleStates };
          const newModuleAdditionalFeatures = { ...moduleAdditionalFeatures };

          moduleList.forEach(menuGroup => {
            menuGroup.items.forEach(item => {
              const moduleKey = formatKey(item.submenu || menuGroup.menu);
              const moduleId = item.id;
              const permission = sourceData.permissions[moduleId];

              if (permission) {
                newSubmoduleStates[moduleKey] = {
                  enabled: permission.menu === "1"
                };

                newModuleSettings[moduleKey] = {
                  list: permission.list === "1",
                  create: permission.create === "1",
                  view: permission.view === "1",
                  edit: permission.edit === "1",
                  delete: permission.delete === "1"
                };

                if (permission.additional && permission.additional.length > 0) {
                  newModuleAdditionalFeatures[moduleKey] = permission.additional.map(feature => ({
                    label: feature,
                    value: feature.toLowerCase().replace(/\s+/g, '_')
                  }));
                }
              }
            });
          });

          setModuleSettings(newModuleSettings);
          setSubmoduleStates(newSubmoduleStates);
          setModuleAdditionalFeatures(newModuleAdditionalFeatures);
        }
      }
    }
  }, [loaded, isEdit, isClone, editData, cloneData, moduleList]);


  useEffect(() => {
    const fetchModules = async () => {
      try {
        const response = await axiosInstance.get('/get_modules');
        if (response.data.success) {
          console.log("Module data:", response.data);
          setModuleList(response.data.data);
          initializeModules(response.data.data);
          setLoaded(true);
        }
      } catch (error) {
        console.error('Error loading modules:', error);
      }
    };

    fetchModules();
  }, []);

  const initializeModules = (modulesData) => {
    const settings = {};
    const subStates = {};
    const additionalFeaturesState = {};

    modulesData.forEach((menuItem) => {
      menuItem.items.forEach((item) => {
        const key = formatKey(item.submenu || menuItem.menu);
        settings[key] = {
          list: false,
          create: false,
          view: false,
          edit: false,
          delete: false
        };
        subStates[key] = { enabled: false };
        additionalFeaturesState[key] = [];
      });
    });

    setModuleSettings(settings);
    setSubmoduleStates(subStates);
    setModuleAdditionalFeatures(additionalFeaturesState);

    const firstModuleKey = Object.keys(settings)[0];
    if (firstModuleKey) setSelectedModule(firstModuleKey);
  };

  const formatKey = (str) => {
    if (!str || typeof str !== 'string') return '';
    return str.toLowerCase().replace(/\s+/g, '_');
  };


  const [moduleSettings, setModuleSettings] = useState({
    projectCreation: { list: false, create: false, view: false, edit: false, delete: false },
    chargeCode: { list: false, create: false, view: false, edit: false, delete: false },
    jobType: { list: false, create: false, view: false, edit: false, delete: false },
    role: { list: false, create: false, view: false, edit: false, delete: false },
    contract: { list: false, create: false, view: false, edit: false, delete: false },
    invoice: { list: false, create: false, view: false, edit: false, delete: false },
    revenue: { list: false, create: false, view: false, edit: false, delete: false },
    cost: { list: false, create: false, view: false, edit: false, delete: false },
    report: { list: false, create: false, view: false, edit: false, delete: false },
    approvalConfiguration: { list: false, create: false, view: false, edit: false, delete: false },
  });


  const [submoduleStates, setSubmoduleStates] = useState({
    projectCreation: { enabled: false },
    chargeCode: { enabled: false },
    jobType: { enabled: false },
    role: { enabled: false },
    contract: { enabled: false },
    revenue: { enabled: false },
    cost: { enabled: false },
    invoice: { enabled: false },
    report: { enabled: false },
    approvalConfiguration: { enabled: false },
  });

  const toggleModule = (module) => {
    if (module === 'modules') {
      setModulesEnabled(!modulesEnabled);
    }
  };

  const toggleSetting = (setting) => {
    setModuleSettings(prev => {
      const updatedSettings = {
        ...prev[selectedModule],
        [setting]: !prev[selectedModule][setting]
      };

      const isEnabled = Object.values(updatedSettings).some(v => v === true);

      setSubmoduleStates(prevState => ({
        ...prevState,
        [selectedModule]: {
          ...prevState[selectedModule],
          enabled: isEnabled
        }
      }));

      return {
        ...prev,
        [selectedModule]: updatedSettings
      };
    });
  };

  const toggleSubmoduleSetting = (module) => {
    const isEnabled = !submoduleStates[module]?.enabled;

    setSubmoduleStates(prev => ({
      ...prev,
      [module]: {
        ...prev[module],
        enabled: isEnabled,
      }
    }));

    setModuleSettings(prev => ({
      ...prev,
      [module]: Object.fromEntries(
        Object.keys(prev[module] || {}).map(key => [key, isEnabled])
      )
    }));
  };

  useEffect(() => {
    const fetchFeatures = async () => {
      if (!selectedModule || !moduleList.length) return;

      const selectedModuleObj = moduleList
        .flatMap(menu => menu.items)
        .find(item => formatKey(item.submenu || item.menu) === selectedModule);

      if (!selectedModuleObj?.id) {
        setAdditionalFeatures([]);
        return;
      }

      try {
        const response = await axiosInstance.get(`/get_additional_features/${selectedModuleObj.id}`);
        if (response.data?.features) {
          setAdditionalFeatures(response.data.features);

          if ((isEdit || isClone) && moduleAdditionalFeatures[selectedModule]) {
            const savedFeatures = moduleAdditionalFeatures[selectedModule];
            const availableFeatures = response.data.features.map(feature => ({
              value: feature.id,
              label: feature.additional_feature,
              module_id: feature.module_id
            }));

            const matchedFeatures = savedFeatures
              .map(savedFeature => {
                return availableFeatures.find(available =>
                  available.label === savedFeature.label
                );
              })
              .filter(Boolean);

            if (matchedFeatures.length > 0) {
              setModuleAdditionalFeatures(prev => ({
                ...prev,
                [selectedModule]: matchedFeatures
              }));
            }
          }
        } else {
          setAdditionalFeatures([]);
        }
      } catch (error) {
        console.error('Error fetching additional features:', error);
        setAdditionalFeatures([]);
      }
    };

    if (selectedModule && moduleList.length > 0) {
      fetchFeatures();
    }
  }, [selectedModule, moduleList, isEdit, isClone]);



  const handleModuleSelect = (module) => {
    setSelectedModule(module);
  };

  const Toggle = ({ enabled, onChange, side = 'right', status = 'none' }) => {
    const modeClass = side === 'left' ? 'left-toggle' : 'right-toggle';
    const sliderClass = enabled ? 'checked' : 'unchecked';

    const colorClass =
      status === 'full' ? 'color-blue' :
        status === 'partial' ? 'color-yellow' :
          'color-grey';

    return (
      <label className={`custom-toggle ${modeClass} ${colorClass}`}>
        <input
          type="checkbox"
          checked={enabled}
          onChange={onChange}
        />
        <span className={`slider ${sliderClass}`} />
      </label>
    );
  };

  const getModuleToggleStatus = (moduleKey) => {
    const settings = moduleSettings[moduleKey];
    const values = Object.values(settings);

    const trueCount = values.filter(v => v).length;
    const totalCount = values.length;

    if (trueCount === 0) return 'none';
    if (trueCount === totalCount) return 'full';
    return 'partial';
  };


  const getCurrentModuleSettings = () => {
    const currentSettings = moduleSettings[selectedModule];
    if (!currentSettings) return null;

    return (
      <>
        {Object.entries(currentSettings).map(([key, enabled]) => {
          const displayName = key.replace(/^./, str => str.toUpperCase());
          return (
            <div className="module-row setting-item" key={key}>
              <div className="module-name">{displayName}</div>
              <div className="toggle-button">
                <Toggle
                  enabled={enabled}
                  onChange={() => toggleSetting(key)}
                  side="right"
                />
              </div>
            </div>
          );
        })}
      </>
    );
  };


  const loadDesignations = async (inputValue) => {
    try {
      const response = await axiosInstance.get('/designation/autosuggestion', {
        params: { term: inputValue }
      });

      if (response.data.success && Array.isArray(response.data.autosuggestion)) {
        const fetched = response.data.autosuggestion.map(designation => ({
          label: designation.label,
          value: String(designation.value)
        }));

        const merged = [...selectedDesignations, ...fetched];

        const unique = [];
        const seen = new Set();

        for (const item of merged) {
          const val = String(item.value);
          if (!seen.has(val)) {
            seen.add(val);
            unique.push(item);
          }
        }

        return unique;
      }
      return [];
    } catch (error) {
      console.error('Error fetching designations:', error);
      return [];
    }
  };


  useEffect(() => {
    const fetchInitialDesignations = async () => {
      const options = await loadDesignations('');
      setDesignationOptions(options);
    };
    fetchInitialDesignations();
  }, []);

  const preparePermissionsData = () => {
    const permissions = {};

    moduleList.forEach(menuGroup => {
      menuGroup.items.forEach(item => {
        const moduleKey = formatKey(item.submenu || menuGroup.menu);
        const moduleId = item.id;

        const isEnabled = submoduleStates[moduleKey]?.enabled || false;
        const moduleFeatures = moduleAdditionalFeatures[moduleKey] || [];

        permissions[moduleId] = {
          menu: isEnabled ? "1" : "0",
          list: (moduleSettings[moduleKey]?.list && isEnabled) ? "1" : "0",
          create: (moduleSettings[moduleKey]?.create && isEnabled) ? "1" : "0",
          view: (moduleSettings[moduleKey]?.view && isEnabled) ? "1" : "0",
          edit: (moduleSettings[moduleKey]?.edit && isEnabled) ? "1" : "0",
          delete: (moduleSettings[moduleKey]?.delete && isEnabled) ? "1" : "0",
          additional: moduleFeatures.map(f => f.label)
        };
      });
    });

    console.log("Final permissions data:", permissions);
    return permissions;
  };

  const handleSave = async () => {
    try {
      const { role_code, role_name } = formData;
      const designation_type_id = selectedDesignations.map(d => d.value).join(',');

      if (!role_code?.trim() || !role_name?.trim() || !designation_type_id) {
        alert('Please fill all required fields');
        return;
      }

      const payload = {
        role_code: role_code.trim(),
        role_name: role_name.trim(),
        designation_type_id,
        permissions: preparePermissionsData()
      };

      console.log("Sending payload:", payload);

      let response;
      if (isEdit) {
        payload.id = roleId;
        response = await axiosInstance.put('/role/update', payload);
        toast.success('Role Updated successfully');
      } else {
        response = await axiosInstance.post('/role/save', payload);
        toast.success(isClone ? 'Role Cloned successfully' : 'Role Saved successfully');
      }

      setTimeout(() => {
        navigate('/roleMaster');
      }, 1000);
    } catch (error) {
      console.error(`Error ${isEdit ? 'updating' : 'saving'} role:`, error);
      const errorMessage = error.response?.data?.message || 'An unexpected error occurred.';
       toast.error(errorMessage); 
    }
  };

  const featureOptions = additionalFeatures
    .filter(feature => {
      const selectedModuleObj = moduleList
        .flatMap(menu => menu.items)
        .find(item => formatKey(item.submenu || item.menu) === selectedModule);

      return feature.module_id === selectedModuleObj?.id;
    })
    .map(feature => ({
      value: feature.id,
      label: feature.additional_feature,
      module_id: feature.module_id
    }));

  const handleFeatureChange = (selectedOptions, moduleKey) => {
    console.log("Updating features for", moduleKey, selectedOptions);
    setModuleAdditionalFeatures(prev => ({
      ...prev,
      [moduleKey]: selectedOptions || []
    }));
  };


  const currentModuleAdditionalFeatures = moduleAdditionalFeatures[selectedModule] || [];



  return (
    <>
      <Masters_header onSearch={null} disableSearch={true} />
      <div className='role-creation'>
        <div className="project_popup_header">
          <div className="project_popup_header_left">
            <img
              src={back_arrow}
              alt="Back Arrow"
              onClick={() => navigate(-1)}
              style={{ cursor: "pointer" }}
            />
            <p style={{ fontSize: '14px', width: 'auto' }} className="new_cost_line">{isEdit ? 'Edit Role' : isClone ? 'Clone Role' : 'New Role'}</p>
          </div>
          <div className="project_popup_header_right">
            <button
              style={{ fontSize: '12px', width: '80px', height: '35px' }}
              className="cancel_btn"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>
            <button
              style={{ fontSize: '12px', width: 'auto', height: '35px' }}
              className="save_btn"
              onClick={handleSave}
            >
              {isEdit ? 'Update' : isClone ? 'Save Clone' : 'Save'}
            </button>
          </div>
        </div>

        <div className="role-creation-form-content">
          <div className="role-creation-form-row">
            <div className="role-creation-form-group">
              <h2 className="role-creation-form-section-title">{isEdit ? 'Edit Role' : isClone ? 'Clone Role' : 'Add Role'}</h2>
              <p className="role-creation-form-section-subtitle">Enter the details for given fields to configure the role.</p>
            </div>

            <div style={{ marginTop: '5px' }} className="role-creation-form-group">
              <label className="role-creation-form-label">Role ID</label>
              <input
                type=""
                className="role-creation-form-control"
                placeholder="Enter the Role ID"
                value={formData.role_code}
                onChange={(e) => setFormData({ ...formData, role_code: e.target.value })}
              />
            </div>

            <div style={{ marginTop: '5px' }} className="role-creation-form-group">
              <label className="role-creation-form-label">Role Name</label>
              <input
                type=""
                className="role-creation-form-control"
                placeholder="Enter role name"
                value={formData.role_name}
                onChange={(e) => setFormData({ ...formData, role_name: e.target.value })}

              />
            </div>

            <div style={{ marginTop: '5px' }} className="role-creation-form-group">
              <label className="role-creation-form-label">Designation Type</label>
              <div style={{ width: '100%' }}>
                <AsyncSelect
                  isMulti
                  value={selectedDesignations}
                  defaultOptions={designationOptions}
                  inputValue={designationInputValue}
                  onChange={(selectedOptions) => {
                    setSelectedDesignations(selectedOptions || []);
                    // Create comma-separated string of IDs
                    const designationIds = selectedOptions ? selectedOptions.map(opt => opt.value).join(',') : '';
                    setFormData({
                      ...formData,
                      designation_type_id: designationIds
                    });
                  }}
                  onInputChange={(value) => {
                    setDesignationInputValue(value);
                  }}
                  loadOptions={loadDesignations}
                  placeholder="Search and select designations..."
                  cacheOptions
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  noOptionsMessage={({ inputValue }) =>
                    inputValue ? "No designations found" : "Type to search designations"
                  }
                  loadingMessage={() => "Searching..."}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      width: '100%',
                      height: '37px',
                      borderRadius: '12px',
                      fontSize: '13px',
                      fontFamily: 'Work Sans',
                      borderColor: state.isFocused ? '#454CF2' : '#D0D6DF',
                      boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                      '&:hover': {
                        borderColor: '#454CF2'
                      },
                      overflow: 'hidden' // ensures valueContainer respects bounds
                    }),
                    valueContainer: (base) => ({
                      ...base,
                      maxHeight: '100%',
                      overflowY: 'auto',
                      overflowX: 'auto',
                      display: 'flex',
                      flexWrap: 'nowrap' // disables wrapping of multiValues to new lines
                    }),
                    container: (base) => ({
                      ...base,
                      width: '100%'
                    }),
                    menu: (base) => ({
                      ...base,
                      fontSize: '13px',
                      fontFamily: 'Work Sans',
                    }),
                    multiValue: (base) => ({
                      ...base,
                      backgroundColor: '#F0F4F8',
                      borderRadius: '4px',
                      padding: '2px 6px',
                      margin: '1px',
                      fontFamily: 'Work Sans',
                    }),
                    multiValueLabel: (base) => ({
                      ...base,
                      color: '#19324C',
                      fontSize: '10px',
                      fontWeight: 500,
                    }),
                    multiValueRemove: (base) => ({
                      ...base,
                      color: '#19324C',
                      ':hover': {
                        backgroundColor: 'transparent',
                        color: '#ff0000'
                      }
                    })
                  }}

                  components={{
                    DropdownIndicator: null,
                    IndicatorSeparator: null,
                    Option: ({ children, ...props }) => (
                      <components.Option {...props}>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                            cursor: 'pointer'
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={selectedDesignations.some(
                              designation => designation.value === props.value
                            )}
                            readOnly
                            style={{
                              marginRight: '8px',
                              cursor: 'pointer'
                            }}
                          />
                          {children}
                        </div>
                      </components.Option>
                    )
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="module-grid-container">
          {/* Left column - Module list (40% width) */}
          <div className="module-column">
            <div className="module-row module-header">
              <div className="module-name">Modules</div>
              <div className="toggle-button">
                <Toggle
                  enabled={modulesEnabled}
                  onChange={() => toggleModule('modules')}
                  side="left"
                />
              </div>
            </div>
            {loaded && modulesEnabled && moduleList.map((menuGroup) =>
              menuGroup.items.map((item) => {
                const key = formatKey(item.submenu || menuGroup.menu);
                const displayName = item.submenu || menuGroup.menu;
                const isSelected = selectedModule === key;
                const toggleStatus = getModuleToggleStatus(key);

                // Dynamically assign badge based on menuGroup
                let badgeLabel = null;
                if (menuGroup.menu === 'Masters') badgeLabel = 'Masters';
                // else if (menuGroup.menu === 'Jobs') badgeLabel = 'Jobs';
                else if (menuGroup.menu === 'Cost Model Creation') badgeLabel = 'Cost Model Creation';
                else if (menuGroup.menu === 'Element Creation') badgeLabel = 'Element Creation';
                else if (menuGroup.menu === 'Project Creation') badgeLabel = 'Project Creation';

                return (
                  <div
                    className={`module-row submodule-item ${isSelected ? 'active' : ''}`}
                    key={key}
                    onClick={() => handleModuleSelect(key)}
                  >
                    <div className="module-name">
                      {displayName}
                      {badgeLabel && (
                        <span className={`badge badge-${badgeLabel.toLowerCase().replace(/\s+/g, '')}`}>
                          {badgeLabel}
                        </span>
                      )}

                    </div>
                    <div className="toggle-button" onClick={(e) => e.stopPropagation()}>
                      <Toggle
                        enabled={submoduleStates[key]?.enabled ?? false}
                        onChange={() => toggleSubmoduleSetting(key)}
                        side="left"
                        status={toggleStatus}
                      />
                    </div>
                  </div>
                );
              })
            )}
          </div>

          {/* Right column - Settings (60% width) */}
          <div className="settings-column">
            <div className="module-row module-header">
              <div className="module-name">
                {selectedModule === 'projectCreation' ? 'Project Creation' :
                  selectedModule.charAt(0).toUpperCase() + selectedModule.slice(1).replace(/([A-Z])/g, ' $1')}
              </div>
              <div className="toggle-button">
                <Toggle
                  enabled={submoduleStates[selectedModule]?.enabled}
                  onChange={() => toggleSubmoduleSetting(selectedModule)}
                  side="right"
                  status={getModuleToggleStatus(selectedModule)}
                />

              </div>
            </div>

            {getCurrentModuleSettings()}
            <div className="module-row additional-features">
              <div className="module-name">Additional Features</div>
              <div className="select-container" style={{ minWidth: '400px' }}>
                <Select
                  isMulti
                  classNamePrefix="addition-react-select"
                  options={featureOptions}
                  value={currentModuleAdditionalFeatures}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  onChange={(selected) => handleFeatureChange(selected, selectedModule)}
                  placeholder="Select features..."
                  menuPortalTarget={document.body}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      width: '100%',
                      minHeight: '37px',
                      borderRadius: '12px',
                      fontSize: '14px',
                      borderColor: state.isFocused ? '#454CF2' : '#D0D6DF',
                      boxShadow: state.isFocused ? '0 0 0 1px #454CF2' : 'none',
                      '&:hover': {
                        borderColor: '#454CF2'
                      }
                    }),
                    container: (base) => ({
                      ...base,
                      width: '100%'
                    }),
                    menu: (base) => ({
                      ...base,
                      fontSize: '13px',

                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999, 
                    }),
                    menuList: (base) => ({
                      ...base,
                      fontFamily: 'Work Sans',
                      maxHeight: '180px', // Set same height as menu
                      overflowY: 'auto', // Make list scrollable
                      padding: 0 // Optional: adjust padding
                    }),
                    multiValue: (base) => ({
                      ...base,
                      backgroundColor: '#F0F4F8',
                      borderRadius: '4px',
                      padding: '2px 6px',
                      margin: '2px'
                    }),
                    multiValueLabel: (base) => ({
                      ...base,
                      color: '#19324C',
                      fontSize: '12px',
                      fontWeight: 500
                    }),
                    multiValueRemove: (base) => ({
                      ...base,
                      color: '#19324C',
                      ':hover': {
                        backgroundColor: 'transparent',
                        color: '#ff0000'
                      }
                    })
                  }}
                  components={{
                    DropdownIndicator: null,
                    IndicatorSeparator: null,
                    Option: ({ children, ...props }) => (
                      <components.Option {...props}>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            width: '100%',
                            cursor: 'pointer',

                          }}
                        >
                          <input
                            type="checkbox"
                            checked={currentModuleAdditionalFeatures.some(
                              feature => feature.value === props.value
                            )}
                            readOnly
                            style={{
                              marginRight: '8px',
                              cursor: 'pointer'
                            }}
                          />
                          {children}
                        </div>
                      </components.Option>
                    )
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <CommonFooter />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
    </>
  );
};

export default RoleCreation;